import React from "react";

import { Box } from "@mui/material";

interface IgResizableDividerProps {
  direction: "horizontal" | "vertical";
  onMouseDown: (e: React.MouseEvent) => void;
  isResizing: boolean;
  /**
   * Length in px of the visible grab bar, centered along the divider.
   * Defaults to spanning the divider's full length.
   */
  handleLength?: number;
}

export const IgResizableDivider: React.FC<IgResizableDividerProps> = ({
  direction,
  onMouseDown,
  isResizing,
  handleLength,
}) => {
  const isHorizontal = direction === "horizontal";
  const barLength = handleLength ? `${handleLength}px` : "100%";

  return (
    <Box
      tabIndex={0}
      onMouseDown={onMouseDown}
      role="separator"
      aria-orientation={isHorizontal ? "vertical" : "horizontal"}
      sx={{
        position: "relative",
        flexShrink: 0,
        cursor: isHorizontal ? "col-resize" : "row-resize",
        userSelect: "none",
        touchAction: "none",
        // Wide, invisible hit area so the divider is easy to grab; the visible
        // line stays thin and centered via the ::before pseudo-element.
        width: isHorizontal ? "11px" : "100%",
        height: isHorizontal ? "100%" : "11px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&::before": {
          content: '""',
          position: "absolute",
          borderRadius: handleLength ? "999px" : "2px",
          backgroundColor: isResizing ? "primary.main" : "divider",
          opacity: isResizing ? 1 : 0.6,
          width: isHorizontal ? "2px" : barLength,
          height: isHorizontal ? barLength : "2px",
          transition: "background-color 0.15s ease, opacity 0.15s ease",
        },
        "&:hover::before": {
          opacity: 1,
          backgroundColor: "primary.main",
          width: isHorizontal ? "3px" : barLength,
          height: isHorizontal ? barLength : "3px",
        },
      }}
    />
  );
};
